// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles for the conversation bubbles */
.chatbot-conversation__human,
.chatbot-conversation__bot {
  padding: 10px 15px;
  border-radius: 20px;
  max-width: 100%;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 5px;
}

/* Human bubble */
.chatbot-conversation__human {
  background-color: #d1e7dd;
  /* Light green */
  color: #0f5132;
  /* Dark green */
}

/* Bot bubble */
.chatbot-conversation__bot {
  background-color: #e9ecef;
  /* Light gray */
  color: #495057;
  /* Dark gray */
}

/* Small labels below the bubbles */
.chatbot-label {
  font-size: 12px;
  color: #6c757d;
  /* Neutral gray */
  margin-top: 2px;
}

/* HTML: <div class="loader"></div> */
.dot-loader {
  width: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
}

@keyframes l5 {
  0% {
    box-shadow: 40px 0 #000, 20px 0 #0002;
    background: #000;
  }
  33% {
    box-shadow: 40px 0 #000, 20px 0 #0002;
    background: #0002;
  }
  66% {
    box-shadow: 40px 0 #0002, 20px 0 #000;
    background: #0002;
  }
  100% {
    box-shadow: 40px 0 #0002, 20px 0 #000;
    background: #000;
  }
}`, "",{"version":3,"sources":["webpack://./../job/src/components/PreAssessmentQuestion/PreAssessmentQuestionChatbot/PreAssessmentChatbotConversation/PreAssessmentChatbotConversation.scss"],"names":[],"mappings":"AAAA,gDAAA;AACA;;EAEE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA,iBAAA;AACA;EACE,yBAAA;EAA2B,gBAAA;EAC3B,cAAA;EAAgB,eAAA;AAGlB;;AAAA,eAAA;AACA;EACE,yBAAA;EAA2B,eAAA;EAC3B,cAAA;EAAgB,cAAA;AAKlB;;AAFA,mCAAA;AACA;EACE,eAAA;EACA,cAAA;EAAgB,iBAAA;EAEhB,eAAA;AAKF;;AAFA,qCAAA;AACA;EACE,UAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;AAKF;;AAHA;EACI;IAAK,qCAAA;IAAsC,gBAAA;EAQ7C;EAPE;IAAK,qCAAA;IAAsC,iBAAA;EAW7C;EAVC;IAAK,qCAAA;IAAsC,iBAAA;EAc5C;EAbA;IAAK,qCAAA;IAAsC,gBAAA;EAiB3C;AACF","sourcesContent":["/* General styles for the conversation bubbles */\n.chatbot-conversation__human,\n.chatbot-conversation__bot {\n  padding: 10px 15px;\n  border-radius: 20px;\n  max-width: 100%;\n  font-size: 14px;\n  line-height: 1.4;\n  margin-bottom: 5px;\n}\n\n/* Human bubble */\n.chatbot-conversation__human {\n  background-color: #d1e7dd; /* Light green */\n  color: #0f5132; /* Dark green */\n}\n\n/* Bot bubble */\n.chatbot-conversation__bot {\n  background-color: #e9ecef; /* Light gray */\n  color: #495057; /* Dark gray */\n}\n\n/* Small labels below the bubbles */\n.chatbot-label {\n  font-size: 12px;\n  color: #6c757d; /* Neutral gray */\n//   text-align: center;\n  margin-top: 2px;\n}\n\n/* HTML: <div class=\"loader\"></div> */\n.dot-loader {\n  width: 8px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  animation: l5 1s infinite linear alternate;\n}\n@keyframes l5 {\n    0%  {box-shadow: 40px 0 #000, 20px 0 #0002;background: #000 }\n    33% {box-shadow: 40px 0 #000, 20px 0 #0002;background: #0002}\n   66% {box-shadow: 40px 0 #0002,20px 0 #000; background: #0002}\n  100%{box-shadow: 40px 0 #0002,20px 0 #000; background: #000 }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
